import { FinanceType, StrapiAsset } from "@/types/api";
import { Stats } from "@/types/state";
import GameEndStatsDisplay from "@/components/screens/GameEndSequence/components/GameEndStatsDisplay";
import DefaultContentContainer from "@/components/shared/DefaultContainer/DefaultContentContainer";
import ScreenIcon from "@/components/icons/ScreenIcon";
import CoinStack from "@/components/screens/GameEndSequence/components/CoinStack";
import { getStrapiMediaUrl } from "@/utils/strapiUtils";
import { useGameEndData } from "@/state/cacheStoreHooks";

type Props = {
    className?: string;
    financeType: FinanceType | null;
    ref?: React.Ref<HTMLDivElement>;
    roomImage: StrapiAsset;
    stats: Stats;
};

const ShareContent = ({ className, financeType, ref, roomImage, stats }: Props) => {
    const gameEndData = useGameEndData();

    const itemImageA = gameEndData?.polaroidItemA;
    const itemImageB = gameEndData?.polaroidItemB;
    return (
        <div className="flex flex-col p-8 bg-secondary-100" style={{ width: "389px", height: "640px" }} ref={ref}>
            <h1 className="text-secondary-500 font-bold text-3xl tracking-tight mb-3 relative z-0">Mein Leben 2045</h1>
            <GameEndStatsDisplay stats={stats} theme="sharescreen" />
            <div className="relative w-full h-[345px] z-10">
                {/* polaroid */}
                <div className="absolute w-[190px] top-[24px] bg-white px-3 pt-3 pb-2 -rotate-[4deg] rounded-[3px] border-[1px] border-secondary-500 flex flex-col gap-1.5 emboss-shadow">
                    {itemImageA && (
                        <div className="absolute z-20 w-[68%] -left-[33%] bottom-[17%]">
                            <img
                                src={getStrapiMediaUrl(itemImageA.url, itemImageA.updatedAt)}
                                className="w-full h-auto"
                                crossOrigin="anonymous"
                                alt=""
                            />
                        </div>
                    )}
                    {itemImageB && (
                        <div className="absolute z-20 w-[42%] -right-[17%] -top-[16%]">
                            <img
                                src={getStrapiMediaUrl(itemImageB.url, itemImageB.updatedAt)}
                                className="w-full h-auto"
                                crossOrigin="anonymous"
                                alt=""
                            />
                        </div>
                    )}
                    <div className="relative w-full" style={{ paddingBottom: `${(194 / 139) * 100}%` }}>
                        <img
                            src={getStrapiMediaUrl(roomImage.url, roomImage.updatedAt)}
                            className="absolute inset-0 object-cover w-full h-full rounded-[3px]"
                            crossOrigin="anonymous"
                            alt=""
                        />
                    </div>
                    <div className="font-handwriting text-black text-center text-xl tracking-tighter">
                        Meine Wohnung :)
                    </div>
                </div>
                {/* coins */}
                <div className="absolute bottom-[-43px] w-[186px] right-[-6px]">
                    <CoinStack />
                </div>
            </div>
            <DefaultContentContainer
                theme="sharescreen"
                rounded="sm"
                shadow={false}
                className="w-full cursor-pointer space-y-2 p-3 text-secondary-500/90 z-20 relative"
            >
                <div className="flex items-center w-full font-bold justify-between  text-xs leading-tight">
                    <span className="tracking-tight">Ich bin Finanztyp</span>
                    <ScreenIcon className="text-secondary-500" />
                </div>
                <div className="text-2xl font-bold leading-5 tracking-normal">{financeType?.name || "--"}</div>
                <div className="leading-5 tracking-tight">{financeType?.subline || "--"}</div>
            </DefaultContentContainer>
        </div>
    );
};

export default ShareContent;
